import { useCallback } from 'react';
import { billsService } from '../services';
import {
  useResourceCollection,
  useResourceById,
  useCreateResource,
  useUpdateResource,
  useDeleteResource,
  ResourceState,
  SingleResourceState,
  MutationState,
} from './useResource';
import { ResourceQueryOptions } from '../services/resources.service';
import { Bill } from '../types';

export function useBills(
  options?: ResourceQueryOptions
): ResourceState<Bill> & { meta?: any } {
  const fetchFn = useCallback(
    (opts?: ResourceQueryOptions) =>
      billsService.getAll(opts) as unknown as Promise<{ data: Bill[]; meta?: any }>,
    []
  );
  return useResourceCollection<Bill>(fetchFn, options);
}

export function useBill(
  id: string | null,
  options?: ResourceQueryOptions
): SingleResourceState<Bill> {
  const resourceId = id;
  const fetchFn = useCallback(
    (billId: string | number, opts?: ResourceQueryOptions) =>
      billsService.getById(billId, opts) as unknown as Promise<Bill>,
    []
  );
  return useResourceById<Bill>(fetchFn, resourceId, options);
}

export function useCreateBill(
  onSuccess?: (data: Bill) => void
): MutationState<Bill> {
  const createFn = useCallback(
    (data: any) => billsService.create(data) as unknown as Promise<Bill>,
    []
  );
  return useCreateResource<Bill>(createFn, onSuccess);
}

export function useUpdateBill(
  onSuccess?: (data: Bill) => void
): MutationState<Bill> {
  const updateFn = useCallback(
    (id: string | number, data: any) => {
      return billsService.update(id, data) as unknown as Promise<Bill>;
    },
    []
  );
  return useUpdateResource<Bill>(updateFn, onSuccess);
}

/**
 * Delete bill using documentId
 * @param data - Full bill object containing documentId
 */
export function useDeleteBill(onSuccess?: () => void): MutationState<void> {
  const deleteFn = useCallback(
    (data: any) => {
      const documentId = data.documentId || data.id?.toString() || data.id;
      return billsService.delete(documentId) as unknown as Promise<void>;
    },
    []
  );
  return useDeleteResource(deleteFn, onSuccess);
}
// Auto-generated hook file
